/// <amd-module name="Artifacts/Package/components/package-details-common/PackageDeletedMessageCard" />
import * as PackageRes from "Artifacts/Package/Resources";
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface IPackageDeletedMessageCardProps {
  packageName: string;
  version: string;
}

export class PackageDeletedMessageCard extends React.PureComponent<
  IPackageDeletedMessageCardProps
> {
  public render(): JSX.Element {
    return (
      <MessageCard severity={MessageCardSeverity.Warning} className="message-card">
        <FormatComponent format={PackageRes.PackageDeletedMessage}>
          {this.props.version}
          {this.props.packageName}
        </FormatComponent>
      </MessageCard>
    );
  }
}
